import * as React from "react";
import contract, { Feature } from "@/utils/contract";
import ContractContext, { initContractStore } from "@/contexts/Contract";

type IGoogleTagManagerId = {
  googleTagManagerId: string | undefined;
};

export const useGoogleTagManagerId = (): IGoogleTagManagerId => {
  const {
    state: { featuresObj, cookieLink, cookieText },
  } = React.useContext(ContractContext) || initContractStore(contract);

  const getGoogleTagManagerIdFn = () => {
    if (
      featuresObj[Feature.GOOGLE_TAG_MANAGER] &&
      featuresObj[Feature.GOOGLE_TAG_MANAGER].googleTagManagerId &&
      ((typeof cookieLink === "string" && cookieLink.length !== 0) ||
        (typeof cookieText === "string" && cookieText.length !== 0))
    ) {
      return featuresObj[Feature.GOOGLE_TAG_MANAGER]?.googleTagManagerId;
    } else return undefined;
  };

  return {
    googleTagManagerId: getGoogleTagManagerIdFn(),
  };
};
